import { ErrorTypes } from "./types";

export const FILE_SIZE_ERROR_NAME: ErrorTypes = "SIZE_LIMIT_EXCEEDED";

export const FILE_TYPE_ERROR_NAME: ErrorTypes = "INVALID_FILE_TYPE";
